import { IdNomeDTO, ResultPagDTO } from '@/interfaces/base-dto';
import {
  FiltroProdutoEnteralParmDTO,
  ProdutoEnteralDetalheDTO,
  ProdutoEnteralListItemDTO,
  ProdutoEnteralParmDTO,
} from '@/interfaces/enteral';
import { ENDPOINTS } from '@/settings/api-settings';
import { from, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { apiClient } from './api';

export function getEnteralProductGroups(): Observable<IdNomeDTO[]> {
  return from(apiClient.get(ENDPOINTS.ENTERAL_PRODUCT_GROUPS)).pipe(
    map((r: any) => {
      return !!r && r.data ? r.data : [];
    }),
  );
}

export function getEnteralProductMakers(): Observable<string[]> {
  return from(apiClient.get(ENDPOINTS.ENTERAL_PRODUCT_MAKERS)).pipe(
    map((r: any) => {
      return !!r && r.data ? r.data : [];
    }),
  );
}

export function getEnteralsProducts(
  filtros: FiltroProdutoEnteralParmDTO,
): Observable<ResultPagDTO<ProdutoEnteralListItemDTO>> {
  return from(apiClient.get(ENDPOINTS.ENTERAL_PRODUCT, filtros)).pipe(
    map((r: any) => {
      return !!r && r.data ? r.data : [];
    }),
  );
}

export function getEnteralProduct(id: Number): Observable<ProdutoEnteralDetalheDTO> {
  return from(apiClient.get(`${ENDPOINTS.ENTERAL_PRODUCT}/${id}`)).pipe(
    map((r: any) => {
      return !!r && r.data ? r.data : [];
    }),
  );
}

export function saveEnteralProduct(produto: ProdutoEnteralParmDTO): Observable<Number> {
  if (produto.id != null) {
    return updateEnteralProduct(produto);
  }
  return from(apiClient.post(ENDPOINTS.ENTERAL_PRODUCT, produto)).pipe(
    map((r: any) => {
      return !!r && r.data ? r.data : [];
    }),
  );
}

export function updateEnteralProduct(produto: ProdutoEnteralParmDTO): Observable<Number> {
  return from(apiClient.put(ENDPOINTS.ENTERAL_PRODUCT, produto)).pipe(
    map((r: any) => {
      return !!r && r.data ? r.data : [];
    }),
  );
}
